import { Field, Form, Formik } from "formik";
import React from "react";
import validationSchema from "../../../Validation/ValidationSchemas";

const SportsAnalysis = ({
  titleSports,
  detailsSports,
  changeHandlerSportz,
  imageNameIDSports,
  imageSportAnalysisUrl,
  getAllSportsAnalysis,
  disabled,
  updateAllSportsAnalysisWeb,
  onFieldChange,
}) => {
  return (
    <div>
      <Formik
        initialValues={{
          title: titleSports,
          details: detailsSports,
        }}
        validationSchema={validationSchema.manageSportAnalysisSchema}
        enableReinitialize
        onSubmit={(values) => updateAllSportsAnalysisWeb(values)}
      >
        {(formik) => (
          <Form>
            <div className="panel-content conclass-website">
              <div className="row">
                <div className="col-lg-8 col-md-12">
                  <label for="comment" className="black fs-18 detailstxt">
                    TITLE (MAXIMUM 5 OR 6 WORDS)
                  </label>
                  <Field
                    type="text"
                    name="title"
                    className={`form-control w-100 faqtextbox1 ${
                      formik.errors.title && "is-invalid"
                    }`}
                    placeholder="Setup your teams"
                  />
                  <div className="errorMsg fs-14 medium">
                    {formik.touched.title && formik.errors.title}
                  </div>
                </div>
                <div className="col-lg-4 col-md-4"></div>
              </div>
              <div className="clear20"></div>
              <div className="row">
                <div className="col-lg-8 col-md-12">
                  <div class="form-group display-grid">
                    <label for="comment" className="black fs-18 detailstxt">
                      DETAILS
                    </label>
                    <Field
                      as="textarea"
                      rows="3"
                      col="12"
                      id="comment"
                      name="details"
                      className={`form-control fs-16 w-100 faqanswerbox ${
                        formik.errors.details && "is-invalid"
                      }`}
                    />
                    <div className="errorMsg fs-14 medium">
                      {formik.touched.details && formik.errors.details}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-8 col-md-12">
                  <label for="comment" className="black fs-18 detailstxt">
                    IMAGE
                  </label>
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-12">
                      <div className="mt-">
                        <label
                          htmlFor="upload-photo-1"
                          className="emailtxtbox w-100 semi-bold txt-blue cp"
                        >
                          <div className="clear10"></div>

                          <u>Browse</u>
                        </label>
                        <input
                          type="file"
                          name="photo"
                          id="upload-photo-1"
                          onChange={changeHandlerSportz}
                        />
                      </div>
                    </div>
                    <div className="col-8 col-md-8 col-lg-8">
                      <div className="clear10"></div>
                      <span className="fs-16 regular addressColor ml-2">
                        {imageNameIDSports}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4"></div>
              </div>
              <hr></hr>
              {imageSportAnalysisUrl && (
                <div className="row">
                  <div className="cd20 d-flex  align-items-center justify-content-center">
                    <img
                      src={imageSportAnalysisUrl}
                      className="img-fluid profileStyle"
                      alt=""
                    ></img>{" "}
                  </div>
                </div>
              )}

              <div className="d-flex-align-cent mg-top-20">
                <button
                  type="button"
                  className="cancelbtn mr-2"
                  onClick={() => getAllSportsAnalysis()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`${
                    formik.isValid ? "saveBtn1" : "saveBtn1 activv"
                  }`}
                  disabled={!formik.isValid}
                >
                  Save
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SportsAnalysis;
